import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import Icon from "../../components/AppIcon";

const API_KEY = import.meta.env.VITE_YOUTUBE_API_KEY;
const CHANNEL_ID = "UCjbOhJLSQsqkxxDOCgRl9ww";

const LiveStreams = () => {
    const [videoId, setVideoId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLatestLive = async () => {
        try {
            setLoading(true);
            setError(null);

            // Buscar los últimos videos del canal (hasta 10, para filtrar)
            const response = await fetch(
                `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${CHANNEL_ID}&order=date&type=video&maxResults=10&key=${API_KEY}`
            );
            const data = await response.json();

            if (!data.items) throw new Error("No se pudieron obtener los videos.");

            // Filtrar solo los que fueron transmisiones en vivo
            const liveVideos = data.items.filter(
                (v) =>
                    v.snippet.liveBroadcastContent === "live" ||
                    v.snippet.liveBroadcastContent === "upcoming" ||
                    v.snippet.title.toLowerCase().includes("en vivo")
            );

            if (liveVideos.length > 0) {
                setVideoId(liveVideos[0].id.videoId);
            } else {
                setVideoId(null);
                setError("No hay transmisiones recientes.");
            }
        } catch (err) {
            console.error("Error al obtener video:", err);
            setError("No se pudo cargar el último directo.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLatestLive();
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Volver */}
                <div className="mb-8">
                    <Link
                        to="/"
                        className="inline-flex items-center text-primary hover:text-accent mb-4"
                    >
                        <Icon name="ArrowLeft" size={16} className="mr-2" />
                        Volver al inicio
                    </Link>
                </div>

                {/* Título principal */}
                <section className="text-center mb-10">
                    <h1 className="font-headline text-3xl md:text-4xl font-bold text-primary mb-3">
                        Clima astral
                    </h1>
                    <p className="font-body text-scholarly-gray text-base md:text-lg max-w-2xl mx-auto">
                        Disfruta del último directo de Rosa María Cifuentes, donde comparte
                        información predictiva sobre los eventos astrológicos más importantes.
                    </p>
                </section>

                {/* Último directo */}
                <section className="mb-12">
                    {loading ? (
                        <div className="text-center text-scholarly-gray">Cargando video...</div>
                    ) : error ? (
                        <div className="text-center text-red-600">{error}</div>
                    ) : videoId ? (
                        <div className="relative w-full aspect-video rounded-lg overflow-hidden literary-shadow hover:literary-shadow-elevated literary-transition">
                            <iframe
                                className="w-full h-full"
                                src={`https://www.youtube.com/embed/${videoId}`}
                                title="Último directo - Rosa María Cifuentes"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    ) : (
                        <div className="text-center text-scholarly-gray">
                            No se encontraron transmisiones recientes.
                        </div>
                    )}
                </section>

                {/* Botón para ver todos los streams */}
                <div className="text-center">
                    <a
                        href="https://www.youtube.com/@RosaMariaCifuentesCanalOficial/streams"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center bg-primary text-primary-foreground font-body px-6 py-3 rounded-full hover:bg-accent literary-shadow hover:literary-shadow-elevated literary-transition"
                    >
                        <Icon name="Youtube" size={18} className="mr-2" />
                        Ver todos los directos en YouTube
                    </a>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default LiveStreams;
